<px-alert
  *ngIf="alerts$ | async"
  [alerts]="alerts$ | async"
  (onCloseAlert)="onCloseAlert($event)"
></px-alert>
